const NUMBER_OF_PAYING_TEAMS = 250000;
export const getLocalizedNumberOfPayingTeams = (localeId)=>NUMBER_OF_PAYING_TEAMS.toLocaleString(localeId || "en");
